var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCensus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.75 112.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.1,20.63h-19.19v-9.09C96.91,5.17,91.74,0,85.36,0h-40.98c-6.38,0-11.54,5.17-11.54,11.54v9.09H13.66C6.13,20.63.03,26.72,0,34.24v60.62c-.15,9.69,7.53,17.71,17.22,17.97h95.31c9.69-.26,17.37-8.28,17.22-17.97v-17.85h0v-42.72c0-7.54-6.11-13.65-13.65-13.66ZM44.39,11.54h40.98v9.09h-40.98v-9.09Zm40.13,63.4h-11.44v11.42c0,.94-.76,1.71-1.71,1.71h-13c-.94,0-1.71-.76-1.71-1.71v-11.43h-11.43c-.94,0-1.71-.76-1.71-1.71v-13c0-.94.76-1.71,1.71-1.71h11.43v-11.43c0-.94.76-1.71,1.71-1.71h13c.94,0,1.71.76,1.71,1.71v11.43h11.42c.94,0,1.71.76,1.71,1.71v13.01c0,.94-.76,1.71-1.7,1.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensus);
export default __webpack_public_path__ + "static/media/Census.008f3cb36e5687bf7ee6c99d83d737b8.svg";
export { ForwardRef as ReactComponent };